import React from "react";
import createReactClass from "create-react-class";
import PropTypes from "prop-types";
import UU5 from "uu5g04";
import "uu5g04-bricks";
import "uu5g04-forms";

import TableCellTextInput from "./table-cell-text-input";

import ns from "ns";

import "./basic-info.less";

export const BasicInfo = createReactClass({
  //@@viewOn:mixins
  mixins: [
    UU5.Common.BaseMixin,
    UU5.Common.NestingLevelMixin,
    UU5.Common.EditableMixin,
    UU5.Forms.FormMixin
  ],
  //@@viewOff:mixins

  //@@viewOn:statics
  statics: {
    tagName: ns.tag("Bricks.BasicInfo"),
    nestingLevelList: UU5.Environment.getNestingLevelList("bigBoxCollection", "box"),
    classNames: {
      main: ns.css("bricks-basic-info"),
      difForm: "basic-info-div-form"
    }
  },

  //@@viewOff:statics

  //@@viewOn:propTypes
  propTypes: {
    data: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
    id: PropTypes.string
  },
  //@@viewOff:propTypes

  //@@viewOn:getDefaultProps
  getDefaultProps() {
    return {
      data: [["", ""]]
    };
  },
  //@@viewOff:getDefaultProps

  //@@viewOn:standardComponentLifeCycle
  componentWillReceiveProps: function (nextProps) {
    this.setState({
      data: JSON.parse(JSON.stringify(nextProps.data))
    });
  },

  componentDidMount() {
    this._clickListener = window.addEventListener("click", this._handleClickEvent);
  },

  componentWillUnmount() {
    window.removeEventListener("click", this._handleClickEvent);
  },

  getInitialState() {
    this._refy = {};
    this._focused = null;
    this.fragments = [["", ""]];
    return {
      editation: false,
      data: this.props.data
    };
  },
  //@@viewOff:standardComponentLifeCycle

  //@@viewOn:interface
  initComponentFragmentation(dccCallback) {
    //on start editation it returns [{data: uu5string, onDataChange: ()=>{callback}}]
    this.dccCallback = dccCallback;
    this._parseDataToFragments(this.state.data, dccCallback);
  },
  //on end editation reset dccmode to show
  initComponentDefragmentation() {
    //clean fragments
  },
  //@@viewOff:interface

  //@@viewOn:overridingMethods
  _handleClickEvent(evt) {
    if (this.state.editation) {
      if (!this._freshFocus && this._focused != null && this._domNode !== evt.target) {
        this._refy[this._focused].doBlur();
        this._focused = null;
      } else {
        this._freshFocus = false;
      }
    }
  },
  forceEndEditationHandler_() {
    return {
      callback: () => this.setState({
        data: JSON.parse(JSON.stringify(this.props.data))
      })
    };
  },
  _updateSingleFragment(fragment, rowIndex, columnIndex) {
    // This part handles case, when fragment got updated by itself, not through BasicInfo data
    if (this.state.data[rowIndex][columnIndex].replace(UU5.Common.REGEXP.uu5string, "") === fragment.dataModel.toString()) {
      //No dataModel update needed && keep fragments actual
      if (!this.fragments[rowIndex]) this.fragments[rowIndex] = ["", ""];
      this.fragments[rowIndex][columnIndex] = fragment;
      this.forceUpdate();
      return null;
    } else {
      return this._updateSingleDataBlock("<uu5string/>" + fragment.dataModel.toString(), rowIndex, columnIndex)
    }
  },

  _updateSingleDataBlock(dataString, rowIndex, columnIndex) {
    let data = this.props.data.slice();
    data[rowIndex][columnIndex] = dataString;
    //When model will update, it will look for prop "data"
    return {"data": data};
  },
  _parseDataToFragments(data, dccCallback) {
    if (data && data[0]) {
      for (let i = 0; i < data.length; i++) {
        /*
        * new data has all same table fields
        * 1 check if data same for the component
        * 2 check if fragment has same content as new data
        * */
        for (let j = 0; j < data[i].length; j++) {
          if (
            this.fragments[i] &&
            this.fragments[i][j].dataModel &&
            this.fragments[i][j].dataModel.toString() === data[i][j].replace(UU5.Common.REGEXP.uu5string, "")
          ) {
            //Skip fragment update
          } else {
            this._createFragment(data[i][j], i, j, dccCallback);
          }
        }
      }
    }
  },
  _createFragment(dataString, rowIndex, columnIndex, dccCallback) {
    dccCallback(dataString, function (component, fragment) {
      //Update single fragment callback
      return component._updateSingleFragment(fragment, rowIndex, columnIndex);
    });
  },

  //@@viewOff:overridingMethods

  //@@viewOn:componentSpecificHelpers
  _getStateFromChildren() {
    let cells = this.getValues();
    let newData = new Array();
    for (let i = 0; i < this.state.data.length; i++) {
      newData[i] = new Array(2);
    }
    Object.keys(cells).forEach((key) =>
      newData[key.split("-")[0]][key.split("-")[1]] = cells[key]
    );
    return newData;
  },

  _save() {
    this.endEditation({"data": this._getStateFromChildren()});
  },

  _cancel() {
    this.endEditation(null, () => {
      return this.setState({data: JSON.parse(JSON.stringify(this.props.data))})
    });
  },

  _openContextMenu(index, evt) {
    console.log(this.state.editation);
    if (this.state.editation) {
      evt.preventDefault();
      this._rowEditNumber = index;
      this._contextMenu.open({event: evt});
    }
  },

  _addOrRemoveRow(type) {
    let index = this._rowEditNumber;
    let currentState = this._getStateFromChildren();
    let newState = [];
    if (type === 1) {
      for (let i = 0; i < currentState.length; i++) {
        if (i == index) {
          newState.push(["", ""]);
          newState.push(currentState[i]);
        } else {
          newState.push(currentState[i]);
        }
      }
    } else if (type === 2) {
      for (let i = 0; i < currentState.length; i++) {
        if (i == index) {
          newState.push(currentState[i]);
          newState.push(["", ""]);
        } else {
          newState.push(currentState[i]);
        }
      }
    } else if (type === 3) {
      for (let i = 0; i < currentState.length; i++) {
        if (i != index) {
          newState.push(currentState[i]);
        }
      }
    }
    this.setState({data: newState});
  },

  _getContextMenu() {
    if (this.state.editation) {
      return <UU5.Bricks.ContextMenu ref_={(contextMenu) => this._contextMenu = contextMenu}>
        <UU5.Bricks.ContextMenu.Item
          label="Vložit řádek před"
          onClick={(evt) => {
            this._addOrRemoveRow(1), evt.component.close()
          }}
        />
        <UU5.Bricks.ContextMenu.Item
          label="Vložit řádek za"
          onClick={(evt) => {
            this._addOrRemoveRow(2), evt.component.close()
          }}
        />
        {this.state.data.length > 1 && <UU5.Bricks.ContextMenu.Item
          label="Smazat řádek"
          onClick={(evt) => {
            this._addOrRemoveRow(3), evt.component.close()
          }}
        />
        }
      </UU5.Bricks.ContextMenu>;
    }
  },

  _getChild() {
    let mainProps = this.getMainPropsToPass();
    return (
      <UU5.Bricks.LsiContext>
        <UU5.Bricks.Div className={this.getClassName("main") + "_root"} ref={(domNode) => this._domNode = domNode}>
          <UU5.Forms.Form className={this.getClassName("difForm")} ref_={(formA) => this._form = formA}
                          onSave={this.state.editation ? () => this._save() : null}
                          onCancel={this.state.editation ? () => this._cancel() : null}>
            <UU5.Bricks.Table {...mainProps}>
              <UU5.Bricks.Table.TBody>
                {this._renderBasicInfoRows()}
              </UU5.Bricks.Table.TBody>
            </UU5.Bricks.Table>
            {this.state.editation && <UU5.Forms.Controls className="div-buttons"/>}
          </UU5.Forms.Form>
          {this.state.editation && this._getContextMenu()}
        </UU5.Bricks.Div>
      </UU5.Bricks.LsiContext>
    );
  },

  _setFocus(index) {
    if (this._focused != null) {
      this._refy[this._focused].doBlur();
    }
    this._refy[index].doFocus();
    this._focused = index;
    this._freshFocus = true;
  },

  _renderBasicInfoRows() {
    let data = this.state.data;
    return (
      data &&
      data.map((row, i) => {
          if (row.length !== 0) {
            let rowId = "basic-info-tr_" + i;
            return (
              <UU5.Bricks.Table.Tr key={rowId} id={rowId} allowTags={["UuDocKit.Bricks.TableCell"]}
                                   mainAttrs={{onContextMenu: (evt) => this._openContextMenu(i, evt)}}>
                <UU5.Bricks.Table.Th key="no-edit-first"
                                     mainAttrs={{onClick: this.state.editation ? () => this._setFocus(i + "-0") : null}}
                                     content=
                                       { //if this.state.editation => data showed, not fragment
                                         this.state.editation ?
                                           <TableCellTextInput
                                             setFocus={() => this._setFocus(i + "-0")}
                                             ref_={(toto) => this._refy[i + "-0"] = toto}
                                             key="label-cell-content" name={i + "-0"}
                                             pureRender={true}
                                             id={i + "-0"}
                                             data={data[i][0]}
                                           /> : (
                                             //fragments will be showed only when its not state.edition, and dcc is in ModeEdit
                                             (this.fragments[i] && this.fragments[i][0].dataModel && this.fragments[i][0].dataModel.toChildren()) || (row && row[0])
                                           )
                                       }/>
                <UU5.Bricks.Table.Td key="no-edit-second"
                                     mainAttrs={{onClick: this.state.editation ? () => this._setFocus(i + "-1") : null}}
                                     content=
                                       {this.state.editation ?
                                         <TableCellTextInput
                                           setFocus={() => this._setFocus(i + "-1")}
                                           key="value-cell-content" name={i + "-1"}
                                           ref_={(toto) => {
                                             this._refy[i + "-1"] = toto;
                                           }}
                                           pureRender={true}
                                           id={i + "-1"}
                                           data={data[i][1]}
                                         /> : (
                                           (this.fragments[i] && this.fragments[i][1].dataModel && this.fragments[i][1].dataModel.toChildren()) || (row && row[1])
                                         )
                                       }/>
              </UU5.Bricks.Table.Tr>
            )
          }
        }
      )
    );
  },
  //@@viewOff:componentSpecificHelpers

  //@@viewOn:render
  render: function () {
    return this.getNestingLevel() ? this._getChild() : null;
  }
  //@@viewOff:render
});

export default BasicInfo;



// WEBPACK FOOTER //
// ./bricks/basic-info.js